import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { SandboxFolderConfigComponent } from './sandbox-folder-config/sandbox-folder-config.component';
import { AppGlobals } from 'src/app/app.globals';
import { FeatureFlags } from 'src/app/interfaces/enums/feature-flag';
import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';

@Component({
    selector: 'app-folder-config',
    imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet, SandboxFolderConfigComponent],
    templateUrl: './folder-config.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './folder-config.component.css'
})
export class FolderConfigComponent implements OnInit {
  tabs = [
    { text: $localize`:@@folderConfigSiteTab:Site`, link: 'site' },
    { text: $localize`:@@folderConfigProjectTab:Project`, link: 'project' },
  ];

  sandboxEnabled = AppGlobals.UserCan(FeatureFlags.Sandbox);

  constructor(
    private router: Router,
    private activityLog: ActivityLogService
  ) {}

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.CONFIG_FOLDERS });
  }

  get activeContext(): 'site' | 'project' {
    return this.router.url.includes('project') ? 'project' : 'site';
  }
}
